"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  white_label: {
    powered_by: 'Powered by'
  },
  errors: {
    parameter_not_unique: 'This value is taken.',
    blank: 'This field is required.'
  },
  forms: {
    phone: 'Click the link sent via SMS to verify your submission.',
    email: 'Click the link sent via email to verify your submission.',
    phone_and_email: 'Click the links sent via SMS and email to verify your submission.',
    none: 'Your submission has been received.'
  }
};
exports.default = _default;